import React from 'react';
import ReactDOM from 'react-dom/client';
import { setWorkerUrl } from 'maplibre-gl';
import maplibreWorkerUrl from 'maplibre-gl/dist/maplibre-gl-worker.mjs?worker&url';

import App from './App';
import GlobalStyles from '~/components/common/GlobalStyles';
import './i18next';

setWorkerUrl(maplibreWorkerUrl);

const root = ReactDOM.createRoot(window.document.getElementById('root')!);
root.render(
  <GlobalStyles>
    <App />
  </GlobalStyles>
);
